<template>
  <div class="si-check-availability-area pb-100">
    <div class="container">
      <div class="row justify-content-center align-items-center g-5">
        <div
          class="col-lg-7 col-md-12"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="si-check-availability-content">
            <span class="top-title">التحقق من التغطية</span>
            <h2>
              تحقق من توفر الخدمة وسرعة البث في منطقتك فوراً
            </h2>
            <p>
              مع سرعات سيرفراتنا العالية، يمكنك الاتصال، المشاهدة، والاستمتاع بـ البث المباشر بجودة 4K و VIP بدون تقطيع.
            </p>
            <form class="check-form" @submit.prevent="window.open('https://wa.me/447429916178', '_blank')">
              <select class="form-select">
                <option selected>اختر نوع جهازك</option>
                <option value="1">شاشة ذكية (Smart TV)</option>
                <option value="2">جهاز أندرويد / تي في بوكس</option>
                <option value="3">هاتف ذكي / كمبيوتر</option>
              </select>
              <div class="check-btn">
                <button type="submit" class="btn">
                  <span class="border-style">تواصل للتفعيل الفوري</span>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div
          class="col-lg-5 col-md-12"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="si-check-availability-image">
            <img
              src="@/assets/images/satellite-internet/check-availability.png"
              alt="image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CheckAvailability",
  setup() {
    return {
      window
    };
  }
});
</script>